// extracted by mini-css-extract-plugin
module.exports = {"mobileGrid":"ProductList_mobileGrid__1ENu_"};